import KnownActionFormPage from './KnownActionFormPage';

export default KnownActionFormPage;